import { useEffect, useState } from "react"
import { Modal } from "antd"
import { ModelFigureSelect } from "~/components"
import { useModelFigures } from "~/common/video/useModelFigures"
import styles from "./index.css"

export const ModelPicker = ({
  selected,
  onCancel,
  onConfirm,
}: {
  selected?: string
  onCancel: () => void
  onConfirm: (model: API.Model.ModelFigure) => void
}) => {
  const { items, error, status, load } = useModelFigures()
  const [value, setValue] = useState(selected || "")
  useEffect(() => {
    void load()
  }, [load])
  return (
    <Modal
      title="选择系统模特"
      open
      width={760}
      onCancel={onCancel}
      onOk={() => {
        const model = items.find((item) => item.model_id === value)
        if (model) onConfirm(model)
      }}
      okText="使用此模特"
      okButtonProps={{
        disabled: !items.some((item) => item.model_id === value),
      }}
    >
      <div className={styles.models}>
        <ModelFigureSelect
          items={items}
          value={value}
          status={status}
          error={error}
          onRetry={() => void load()}
          onSelect={(id) => setValue(value === id ? "" : id)}
        />
      </div>
    </Modal>
  )
}
